<script setup lang="ts">
withDefaults(
  defineProps<{
    ariaLabel?: string;
    /**
     * Let the group shrink below its widest chip (`min-width: 0`), so a
     * truncating badge inside (`NxBadge truncate`) is cut at the column
     * instead of pushing the row past it. Off by default: a group otherwise
     * keeps its chips whole.
     */
    shrink?: boolean;
  }>(),
  { ariaLabel: undefined, shrink: false }
);
</script>

<template>
  <div class="nx-chip-group" :class="{ 'is-shrink': shrink }" role="group" :aria-label="ariaLabel">
    <slot />
  </div>
</template>

<style scoped>
.nx-chip-group {
  display: flex;
  flex-wrap: wrap;
  gap: var(--nxt-space-xs);
  align-items: center;
}
.nx-chip-group.is-shrink {
  min-width: 0;
}
</style>
